import { apiGet } from './client';
import { PRODUCT_WIKI_SLUG } from './projects';

export interface UpdateSummary {
  date: string;
  count: number;
  statuses: Record<string, number>;
}

export interface UpdateDayResponse {
  date: string;
  html: string;
  entryCount: number;
}

export function listUpdates(): Promise<UpdateSummary[]> {
  return apiGet<UpdateSummary[]>(`/${PRODUCT_WIKI_SLUG}/updates`);
}

export function getUpdateDay(date: string): Promise<UpdateDayResponse> {
  return apiGet<UpdateDayResponse>(`/${PRODUCT_WIKI_SLUG}/updates/${encodeURIComponent(date)}`);
}
